import { Grid, Stack } from '@mui/material'
import AuroraAssetGroupMinTemperatureLimitControl from './AuroraAssetGroupMinTemperatureLimitControl'
import AuroraAssetGroupMaxTemperatureLimitControl from './AuroraAssetGroupMaxTemperatureLimitControl'
import AuroraAssetGroupMinPressureLimitControl from './AuroraAssetGroupMinPressureLimitControl'
import AuroraAssetGroupMaxPressureLimitControl from './AuroraAssetGroupMaxPressureLimitControl'
import AuroraAssetGroupMinFlowLimitControl from './AuroraAssetGroupMinFlowLimitControl'
import AuroraAssetGroupHeatingElementControls from './AuroraAssetGroupHeatingElementControls'
import AuroraControlModeToggle from './AuroraControlModeToggle'
import { AuroraAssetGroup } from '../types'
import { AuroraControlMode } from '../enums'
import { useAuroraStack } from '../hooks/aurora'

export interface AuroraAssetGroupAdvancedControlsProps {
  auroraAssetGroup: AuroraAssetGroup
  mode?: AuroraControlMode
  onModeChange?: (mode: AuroraControlMode) => void
}

export default function AuroraAssetGroupAdvancedControls({
  auroraAssetGroup,
  mode = AuroraControlMode.STACK,
  onModeChange
}: AuroraAssetGroupAdvancedControlsProps) {
  const { hasAwhpUnits } = useAuroraStack(auroraAssetGroup)

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupMinTemperatureLimitControl auroraAssetGroup={auroraAssetGroup} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupMaxTemperatureLimitControl auroraAssetGroup={auroraAssetGroup} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupMinPressureLimitControl auroraAssetGroup={auroraAssetGroup} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupMaxPressureLimitControl auroraAssetGroup={auroraAssetGroup} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupMinFlowLimitControl auroraAssetGroup={auroraAssetGroup} />
      </Grid>
      <Grid item xs={12} lg={6}></Grid>

      {hasAwhpUnits && (
        <>
          <Grid item xs={12} lg={6}>
            <AuroraAssetGroupHeatingElementControls
              auroraAssetGroup={auroraAssetGroup}
              element={1}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <AuroraAssetGroupHeatingElementControls
              auroraAssetGroup={auroraAssetGroup}
              element={2}
            />
          </Grid>
        </>
      )}

      {onModeChange && (
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="center" alignItems="center">
            <AuroraControlModeToggle mode={mode} onModeChange={onModeChange} />
          </Stack>
        </Grid>
      )}
    </Grid>
  )
}
